"use client";

import "./globals.css";

import { useEffect } from "react";

import { ErrorReportList } from "@/components/errors/error-report-list";
import { Button } from "@/components/ui/button";
import { reportUnexpectedError } from "@/lib/errors/from-error";
import { useErrorReportEnvironment, useErrorReports } from "@/lib/errors/report";

/**
 * ルートのレイアウト自体の例外（レイアウトごと差し替わるので、ダイアログの代わりにここへ全部出す）。
 *
 * @param props.error - 例外。
 * @param props.unstable_retry - 再試行。
 */
export default function GlobalError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  const reports = useErrorReports();
  const env = useErrorReportEnvironment();
  useEffect(() => {
    reportUnexpectedError(error, "render", error.digest ?? null);
  }, [error]);
  return (
    <html lang="ja">
      <body className="p-6">
        <title>エラー | Nexus</title>
        <div className="mx-auto flex max-w-5xl flex-col gap-3" role="alert">
          <h1 className="text-base font-medium text-destructive">エラーが発生しました</h1>
          <p className="text-sm text-muted-foreground">
            この画面のスクリーンショットを撮って、問い合わせ先へ送ってください（「すべてコピー」で文字でも送れます）。
          </p>
          <ErrorReportList
            reports={reports}
            env={env}
            actions={
              <Button type="button" onClick={unstable_retry}>
                もう一度表示する
              </Button>
            }
          />
        </div>
      </body>
    </html>
  );
}
